import React, { FC } from "react";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Button } from "@mui/material";

interface FormAttachmentProps {
	id: number;
	filename: string;
	handleDelete: (id: number) => Promise<void>;
}

export const FormAttachment: FC<FormAttachmentProps> = (props) => {
	return (
		<Button key={props.id} onClick={() => props.handleDelete(props.id)}>
			{props.filename}
			<DeleteForeverIcon />
		</Button>
	);
};
